import React from "react";
import { HelmetProvider } from 'react-helmet-async';
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import './utils/i18n';
import { Provider } from "react-redux";
import {store} from "../src/redux/store/store";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
  <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
  <Provider store={store}>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </Provider>
  </GoogleOAuthProvider>
  </HelmetProvider>
);

serviceWorkerRegistration.unregister();
